import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';

export class BuddiesStrawberry extends View {
  private icon: ImageScaleView;

  constructor(opts?: ViewOpts) {
    super({
      ...opts,
      width: 89,
      height: 98,
      centerOnOrigin: true,
    });

    this.icon = new ImageScaleView({
      superview: this,
      image: 'assets/ui/buddies/common/strawberry_large.png',
      width: this.style.width,
      height: this.style.height,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: this.style.height / 2,
    });
  }
}
